/**
 * The role a user can have.
 */
export enum UserRole {
  Admin = 'admin',
  Breeder = 'breeder',
  ServiceProvider = 'service_provider',
  User = 'user',
}
